// components
import CommonForm from "../Common/CommonForm";
import CommonActionModal from "../Common/CommonActionModal";

// icons
import AddCircleIcon from '@mui/icons-material/AddCircle';
import TableViewIcon from "@mui/icons-material/TableView";


class FinancialModelSalaryCreate extends CommonActionModal {
    async componentDidMount() {
        this.setState({
            buttonIcon: this.props.buttonIcon?this.props.buttonIcon:AddCircleIcon,
            buttonLabel: this.props.buttonLabel?this.props.buttonLabel:'Добавить',
            buttonColor: 'neutral',
            ready: true,
            flat: this.props.flat,
        })
    }

    async beforeModalOpen(){
        let formFields = [
            {
                'name': 'title',
                'label': 'Заголовок',
                'xs': 12,
                'sm': null,
                'md': null,
                'lg': null,
                'xl': null,
                'required': true,
                'default': '',
                'type': 'input',
            },
            {
                'name': 'count',
                'label': 'Количество раз',
                'xs': 12,
                'sm': null,
                'md': null,
                'lg': null,
                'xl': null,
                'required': true,
                'default': 1,
                'type': 'number',
            },
            {
                'name': 'value',
                'label': 'Значение',
                'xs': 12,
                'sm': null,
                'md': null,
                'lg': null,
                'xl': null,
                'required': true,
                'default': 1,
                'type': 'number',
            },
            {
                type: 'submit',
                label: this.props.submitLabel?this.props.submitLabel:'Добавить'
            }
        ]
        return {
            modalLabel: 'Добавление инженерного работника',
            modalIcon: TableViewIcon,
            mainComponent: CommonForm,
            mainComponentProps: {
                fields: formFields,
                object: this.props.componentObj,
                processForm: this.processForm.bind(this),
            },
        }
    }

    async processForm(form) {
        let data = Object.fromEntries(form.state.formData.entries());
        data.id = this.props.componentObj?.id;
        await this.props.callBack(data);
        await this.setModalOpenFalse()
    }
}

export default FinancialModelSalaryCreate
